export const SET_LOADING_DATA = '@commissionReport/SET_LOADING_DATA';
export const GET_LIST_ALL_REQUEST = '@commissionReport/GET_LIST_ALL_REQUEST';
export const GET_LIST_ALL_SUCCESS = '@commissionReport/GET_LIST_ALL_SUCCESS';
export const SHARE_CSV = '@commissionReport/SHARE_CSV';
export const SET_PAGE = '@commissionReport/SET_PAGE';
export const SET_ROWS_COUNT = '@commissionReport/SET_ROWS_COUNT';
export const SET_ROWS_PER_PAGE = '@commissionReport/SET_ROWS_PER_PAGE';
export const GET_DETAILS_REQUEST = '@commissionReport/GET_DETAILS_REQUEST';
export const GET_DETAILS_SUCCESS = '@commissionReport/GET_DETAILS_SUCCESS';
export const SET_LOADING_DETAILS = '@commissionReport/SET_LOADING_DETAILS';
export const CLEAR_DETAILS = '@commissionReport/CLEAR_DETAILS';
